import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["href"]

import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useGWAnalytics } from '@/plugins/analytics'


export default /*#__PURE__*/_defineComponent({
  __name: 'WebsiteLink',
  setup(__props) {

const route = useRoute()
const { locale, t } = useI18n()
const { vAnalyticsClick } = useGWAnalytics()

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("a", {
    href: 'https://gentlemansworld.sk/' + _unref(locale) + '/',
    target: "_blank"
  }, [
    _createTextVNode(_toDisplayString(_unref(t)('back_to_webpage')), 1)
  ], 8, _hoisted_1)), [
    [_unref(vAnalyticsClick), _unref(route)]
  ])
}
}

})